<div #animationRoot class="wvr-components wvr-card card {{additionalCardClasses}}" [ngClass]="{ 'text-center': textCenter, 'collapsed': _collapsed === 'true' }">
  <div class="card-header {{additionalHeaderClasses}}" [wvrContentProjection]="eRef" template="card-header" (click)="toggleCollapsibleClick()" [attr.tabindex]="collapseMethod === 'click' ? '0' : null"></div>
  <div class="card-image" [wvrContentProjection]="eRef" template="card-image"></div>
  <div [wvrContentProjection]="eRef" template="card-list-top"></div>
  <div class="card-body">
    <h5 class="card-title" [wvrContentProjection]="eRef" template="card-title"></h5>
    <h6 class="card-subtitle" [wvrContentProjection]="eRef" template="card-subtitle"></h6>
    <p class="card-text" [wvrContentProjection]="eRef" template="card-text"></p>
    <div [wvrContentProjection]="eRef" template="card-content"></div>
  </div>
  <div [wvrContentProjection]="eRef" template="card-list-bottom"></div>
  <div class="card-body card-links" [wvrContentProjection]="eRef" template="card-links"></div>
  <div class="card-body card-buttons" [wvrContentProjection]="eRef" template="card-buttons"></div>
  <div class="card-footer" [wvrContentProjection]="eRef" template="card-footer"></div>
</div>

<ng-content select="template"></ng-content>
